import {combineReducers} from 'redux';
import {LOGOUT} from '../constants/idpAdminActions'

import auth from './auth';
import azure from './azure';
import sp from './sp';
import idp from './idp';
import customization from './customization';
import logout from './logout';

const appReducer = combineReducers({
  auth,
  azure,
  sp,
  idp,
  customization,
  logout,
});
const rootReducer = (state, action) => {
  if (action.type === LOGOUT) {
    state = undefined;
  }
  return appReducer(state, action);
}
export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js